import { render } from "./DashoboardLogos.vue?vue&type=template&id=36d2f672"
import script from "./DashoboardLogos.vue?vue&type=script&lang=js"
export * from "./DashoboardLogos.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__